import { useContext } from 'react'
import MessagingContext from 'contexts/messaging/MessagingProvider'

export const checkSocketUserIsConnected = (userId: string): boolean => {
  const {onlineUsers} = useContext(MessagingContext)
    const user = onlineUsers?.find(u => u.id === userId)
    if (user) return user.connected
    return false
  }